import styled from 'styled-components';

export const StyledYesNoResponse = styled.span`
  .radio {
    margin-right: 0px !important;
    margin-left: 4px !important;
  }
`;
